import {Injectable} from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  
  private _activeStep$ = new BehaviorSubject<number>(0);
  public get activeStep$(): Observable<number> { return this._activeStep$.asObservable(); }

  setActiveStep(step: number): void {
    this._activeStep$.next(step);
  }
}
